import {
	ISearchService, ISearchCriteria, ISearchResult,
	IProgram, ICourse, IFacetValue, IFacets, SearchType
} from './ISearchService';
import store from '../store';
import axios from 'axios';

// eslint-disable-next-line
type mapperFunc = ((node: any) => IProgram) | ((node: any) => ICourse);

export class AzureSearchService implements ISearchService {
	private config = store.state.config;

	private apiKey = this.config.queryKey;

	private serviceName = this.config.serviceName;
	private apiVersion = '2020-06-30';

	private programUrl = `https://${this.serviceName}.search.windows.net/indexes/${this.config.programIndexName}` +
		`/docs/search?api-version=${this.apiVersion}`;

	private courseUrl = `https://${this.serviceName}.search.windows.net/indexes/${this.config.courseIndexName}` +
		`/docs/search?api-version=${this.apiVersion}`;

	public async search (criteria: ISearchCriteria): Promise<ISearchResult> {
		const pageSize = criteria.pageSize || 10;
		const skip = pageSize * ((criteria.page || 1) - 1);

		const searchType = criteria.searchType;

		const url = searchType === SearchType.Program ? this.programUrl : this.courseUrl;

		// TODO:TRS Condider using FacetMetadata as the source
		const searchFacets = searchType === SearchType.Program
			? ['deliveryMode', 'msiCodes', 'level,count:11', 'area,count:11', 'deliverySpeed', 'language', 'state,count:11']
			: ['yearTerm', 'msiCodes', 'deliveryMode', 'courseLevel', 'area,count:11', 'deliverySpeed', 'language', 'state,count:11'];

		const mapper: mapperFunc = searchType === SearchType.Program ? asProgram : asCourse;

		const response = await axios({
			method: 'post',
			url,
			data: {
				search: criteria.term,
				searchMode: criteria.matchAll ? 'all' : 'any',
				queryType: criteria.fullSearch ? 'full' : 'simple',
				filter: criteria.filter,
				count: true,
				facets: searchFacets,
				scoringProfile: criteria.scoringProfile,
				top: pageSize,
				skip,
				orderby: criteria.sort
			},
			headers: { 'api-key': this.apiKey }
		});

		// TODO:TRS Is there a lint worthy way to handle AxiosResponse<any>?
		// eslint-disable-next-line
		const data = response.data as any;

		const items = data.value.map((p: IProgram | ICourse) => mapper(p));

		const count = data['@odata.count'];

		const facetNode = data['@search.facets'];

		const facets = facetNode as IFacets;

		return {
			searchType,
			items,
			count,
			facets
		};
	}

	public async facet (criteria: ISearchCriteria, column: string): Promise<IFacetValue[]> {
		const searchType = criteria.searchType;

		const url = searchType === SearchType.Program ? this.programUrl : this.courseUrl;

		const response = await axios({
			method: 'post',
			url,
			data: {
				search: criteria.term,
				searchMode: criteria.matchAll ? 'all' : 'any',
				queryType: criteria.fullSearch ? 'full' : 'simple',
				filter: criteria.filter,
				facets: [`${column},count:2000`],
				scoringProfile: criteria.scoringProfile,
				top: 0
			},
			headers: { 'api-key': this.apiKey }
		});

		// TODO:TRS Is there a lint worthy way to handle AxiosResponse<any>?
		// eslint-disable-next-line
		const facetNode = (response.data as any)['@search.facets'];

		const facets = facetNode as IFacets;

		return facets[column];
	}
}

function asProgram (node: IProgram): IProgram {
	node.searchScore = +node['@search.score'];
	return node;
}

function asCourse (node: ICourse): ICourse {
	node.searchScore = +node['@search.score'];
	return node;
}
